export const footerText = {
    'right_menu_title': 'Right Menu Title',
    'right_menu_item_1': 'Right Menu Item 1',
    'right_menu_item_2': 'Right Menu Item 2',
    'right_menu_item_3': 'Right Menu Item 3',
    'right_menu_item_4': 'Right Menu Item 4',
    'right_menu_item_5': 'Right Menu Item 5',

    'center_menu_title': 'Center Menu Title',
    'center_menu_item_1': 'Center Menu Item 1',
    'center_menu_item_2': 'Center Menu Item 2',
    'center_menu_item_3': 'Center Menu Item 3',

    'left_menu_title': 'Left Menu Title',
    'left_menu_item_1': 'Left Menu Item 1',
    'left_menu_item_2': 'Left Menu Item 2',
    'left_menu_item_3': 'Left Menu Item 3',

    'footer_text': 'Footer Text',
    'copy_right_year': 'Copy Right Year',

}